// import { useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { vendorApi } from "../../services/vendorApi";
// import { useVendorAuth } from "../../store/vendorAuthStore";

// export default function UpdateShipping() {
//   const { token } = useVendorAuth();
//   const { id } = useParams();
//   const nav = useNavigate();

//   const [status, setStatus] = useState("Shipped");
//   const [tracking_no, setTrackingNo] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState("");

//   const submit = async (e) => {
//     e.preventDefault();
//     setErr("");
//     setLoading(true);
//     try {
//       await vendorApi.updateShipping(token, { order_id: id, status, tracking_no });
//       nav(`/orders/${id}`); // ✅ Fixed
//     } catch (e) {
//       setErr(e.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="vpage">
//       <form className="v-card" onSubmit={submit}>
//         <div className="v-row">
//           <div>
//             <h3 style={{ margin: 0 }}>Update Shipping - Order #{id}</h3>
//             <div className="v-muted">Change status and tracking number</div>
//           </div>
//           <button type="button" className="v-btn v-btn-outline" onClick={() => nav(-1)}>Back</button>
//         </div>

//         {err ? <div className="v-alert v-alert-error">{err}</div> : null}

//         <div className="v-form">
//           <div>
//             <label>Status</label>
//             <select value={status} onChange={(e) => setStatus(e.target.value)}>
//               <option value="Accepted">Accepted</option>
//               <option value="Packed">Packed</option>
//               <option value="Shipped">Shipped</option>
//               <option value="Delivered">Delivered</option>
//             </select>
//           </div>
//           <div>
//             <label>Tracking Number</label>
//             <input value={tracking_no} onChange={(e) => setTrackingNo(e.target.value)} placeholder="Eg: TRK123456" />
//           </div>
//         </div>

//         <div className="v-row" style={{ marginTop: 16 }}>
//           <div className="v-muted">Tip: Tracking number optional. Status must be selected.</div>
//           <button className="v-btn v-btn-primary" disabled={loading}>
//             {loading ? "Updating..." : "Update"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

//new

import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { vendorApi } from "../../services/vendorApi";
import { useVendorAuth } from "../../store/vendorAuthStore";

/* ── Icons ── */
const IconBack = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);
const IconTruck = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13"/>
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
    <circle cx="5.5" cy="18.5" r="2.5"/>
    <circle cx="18.5" cy="18.5" r="2.5"/>
  </svg>
);
const IconCheck = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

/* ── styles ── */
const S = {
  page:       { padding: 24, background: "#f0f2f5", minHeight: "100%", display: "flex", alignItems: "flex-start", justifyContent: "center" },
  card:       { background: "#fff", border: "1px solid #eee", borderRadius: 16, padding: 28, boxShadow: "0 1px 4px rgba(0,0,0,0.04)", width: "100%", maxWidth: 540 },
  cardHead:   { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 14, marginBottom: 24, flexWrap: "wrap" },
  headLeft:   { display: "flex", alignItems: "center", gap: 12 },
  iconBox:    { width: 44, height: 44, background: "#1a1f2e", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  title:      { margin: 0, fontSize: 18, fontWeight: 800, color: "#111", lineHeight: 1.2 },
  sub:        { marginTop: 3, color: "#888", fontSize: 13 },
  backBtn:    { display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 14px", border: "1.5px solid #e2e5ea", background: "#fff", borderRadius: 10, fontSize: 13, fontWeight: 700, color: "#444", cursor: "pointer", whiteSpace: "nowrap" },
  divider:    { height: 1, background: "#f0f0f0", marginBottom: 24 },
  alert:      { padding: "12px 16px", borderRadius: 12, background: "#ffe9e9", border: "1px solid #ffc8c8", color: "#a40000", marginBottom: 18, fontSize: 13.5, fontWeight: 600 },
  form:       { display: "flex", flexDirection: "column", gap: 18 },
  field:      { display: "flex", flexDirection: "column", gap: 7 },
  label:      { fontSize: 13, fontWeight: 700, color: "#444" },
  select:     { padding: "11px 14px", border: "1.5px solid #e2e5ea", borderRadius: 12, fontSize: 14, color: "#222", background: "#fff", outline: "none", width: "100%", boxSizing: "border-box" },
  input:      { padding: "11px 14px", border: "1.5px solid #e2e5ea", borderRadius: 12, fontSize: 14, color: "#222", background: "#fff", outline: "none", width: "100%", boxSizing: "border-box" },
  hint:       { fontSize: 12, color: "#aaa", marginTop: 2 },
  footer:     { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 12, marginTop: 28, paddingTop: 20, borderTop: "1px solid #f0f0f0", flexWrap: "wrap" },
  tip:        { flex: 1, fontSize: 12.5, color: "#aaa", minWidth: 160 },
  submitBtn:  { display: "inline-flex", alignItems: "center", gap: 8, padding: "11px 22px", background: "#1a1f2e", color: "#fff", border: "none", borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" },
  submitBtnDisabled: { opacity: 0.55, cursor: "not-allowed" },
};

export default function UpdateShipping() {
  const { token } = useVendorAuth();
  const { id }    = useParams();
  const nav       = useNavigate();

  const [status,      setStatus]     = useState("Shipped");
  const [tracking_no, setTrackingNo] = useState("");
  const [loading,     setLoading]    = useState(false);
  const [err,         setErr]        = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await vendorApi.updateShipping(token, { order_id: id, status, tracking_no });
      nav(`/orders/${id}`);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>
      <form style={S.card} onSubmit={submit}>

        {/* ── Header ── */}
        <div style={S.cardHead}>
          <div style={S.headLeft}>
            <div style={S.iconBox}><IconTruck /></div>
            <div>
              <h3 style={S.title}>Update Shipping</h3>
              <div style={S.sub}>Order #{id}</div>
            </div>
          </div>
          <button type="button" style={S.backBtn} onClick={() => nav(-1)}>
            <IconBack /> Back
          </button>
        </div>

        <div style={S.divider} />

        {err ? <div style={S.alert}>{err}</div> : null}

        {/* ── Fields ── */}
        <div style={S.form}>
          <div style={S.field}>
            <label style={S.label}>Status</label>
            <select
              style={S.select}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Accepted">Accepted</option>
              <option value="Packed">Packed</option>
              <option value="Shipped">Shipped</option>
              <option value="Delivered">Delivered</option>
            </select>
          </div>

          <div style={S.field}>
            <label style={S.label}>Tracking Number</label>
            <input
              style={S.input}
              value={tracking_no}
              onChange={(e) => setTrackingNo(e.target.value)}
              placeholder="e.g. TRK123456"
            />
            <span style={S.hint}>Tracking number is optional.</span>
          </div>
        </div>

        {/* ── Footer ── */}
        <div style={S.footer}>
          <span style={S.tip}>Status must be selected before updating.</span>
          <button
            type="submit"
            style={{ ...S.submitBtn, ...(loading ? S.submitBtnDisabled : {}) }}
            disabled={loading}
          >
            <IconCheck />
            {loading ? "Updating..." : "Update Shipping"}
          </button>
        </div>

      </form>
    </div>
  );
}